export default __webpack_public_path__ + "static/media/thumbnail.34d7dd7b.png";